import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface TaxonomyItemAttributes {
  COMP_COMPANY: string;
  COMP_PRODUCT: string;
  COMP_NAME: string;
  [key: string]: any;
}

export interface TaxonomyItem {
  attributes: TaxonomyItemAttributes;
  [key: string]: any;
}

interface TaxonomyState {
  competitors: TaxonomyItem[];
  isLoaded: boolean;
}

const initialState: TaxonomyState = {
  competitors: [],
  isLoaded: false,
};

const taxonomySlice = createSlice({
  name: 'taxonomy',
  initialState,
  reducers: {
    setCompetitorsTaxonomy: (state, action: PayloadAction<TaxonomyItem[]>) => {
      state.competitors = action.payload;
      state.isLoaded = true;
    },
  },
});

export const { setCompetitorsTaxonomy } = taxonomySlice.actions;
export default taxonomySlice.reducer;
// Generated by GitHub Copilot | Updated on: 2026-04-13 | 34 lines modified | Created taxonomy RTK slice for storing competitors taxonomy data
// Generated by GitHub Copilot | Updated on: 2026-04-13 | 8 lines modified | Updated TaxonomyItem to use attributes.COMP_COMPANY/COMP_PRODUCT/COMP_NAME
